<template>
	<main v-if="bookmarksData">
		<TopBottomLayout :class="bookmarksData?.count <= 0 && 'ly_favorite'">
			<h6>관심종목</h6>
			<section v-if="(getBannerMulti?.interest?.length ?? 0) > 0" class="c_responsive">
				<SubSwiperSlide :data="getBannerMulti?.interest ?? []" />
			</section>
			<StickyTabBar :items="tabItems" @update:category="onClickTab"></StickyTabBar>
			<div v-if="bookmarksData?.bookmarks.length > 0" class="favorites_content">
				<MoreListLayout class="c_responsive">
					<ListLayout v-if="selectedTab !== 'ETF'">
						<ShortenBookmarkList
							v-for="(item, index) in bookmarksData?.bookmarks.slice(0, moreNumber)"
							:key="item.event_pk"
							:data="item"
							:index="index"
							:is-interest="true"
							@update:book-mark-refetch="handleBookmarkRefetch"
					/></ListLayout>
					<ListLayout v-else>
						<SectorRankList
							:favorite-data="bookmarksData?.bookmarks.slice(0, moreNumber)"
							@update:book-mark-refetch="handleBookmarkRefetch"
					/></ListLayout>
					<MoreButton
						v-if="moreNumber < (bookmarksData?.count ?? 0)"
						:disabled="isFetchingNextPage"
						@click="onClickBookmarkMore"
				/></MoreListLayout>
			</div>
			<div v-else class="favorites_content_not">
				<p class="guide_not-content">관심 설정한 종목이 없습니다.</p>
			</div>
		</TopBottomLayout>
	</main>
</template>

<script setup lang="ts">
// core
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';

// api
import { useGetBannerMultiApi } from '@/api/banner';
import { useGetBookmarksUSAInfiniteApi } from '@/api/Interest';
import MoreButton from '@/components/atom/button/MoreButton.vue';
// component
import StickyTabBar from '@/components/atom/tabBar/StickyTabBar.vue';
import SectorRankList from '@/components/etf/SectorRankList.vue';
import ListLayout from '@/components/layout/main/ListLayout.vue';
import MoreListLayout from '@/components/layout/main/MoreListLayout.vue';
import TopBottomLayout from '@/components/layout/main/TopBottomLayout.vue';
import ShortenBookmarkList from '@/components/rankList/ShortenBookmarkList.vue';
import SubSwiperSlide from '@/components/swiper/SubSwiperSlide.vue';

// -----variable-----
const tabItems = ['미국', 'ETF'];
const route = useRoute();

const selectedTab = computed(() => {
	return route.query.tab ?? '미국';
});

const moreNumber = ref(5);

// -----api-----
const { data: getBannerMulti } = useGetBannerMultiApi({ type: 'interest' });
const {
	data: bookmarksData,
	refetch: refetchBookmarksData,
	fetchNextPage,
	isFetchingNextPage,
} = useGetBookmarksUSAInfiniteApi(computed(() => ({ tab: String(selectedTab.value) })));

// -----function-----
const handleBookmarkRefetch = async () => {
	await refetchBookmarksData();
};
const onClickBookmarkMore = () => {
	fetchNextPage();
	moreNumber.value += 5;
};
const onClickTab = () => {
	moreNumber.value = 5;
};
</script>

<style lang="scss" scoped>
.favorites_content_not {
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}
.guide_not-content {
	font-size: var(--font-s-mid);
	font-weight: var(--font-w-semi-bold);
	line-height: normal;
	text-align: center;
}

.ly_favorite {
	justify-content: unset;
	height: calc(100dvh - var(--footer-height));
}
</style>
